module.exports = __webpack_public_path__ + "static/media/logo.39d49e01.svg";